import React, { useCallback, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import block from 'bem-cn'

import { usePoll } from 'shared/hooks/usePoll'
import { IGetUserPromotionsFilters } from 'shared/models/BonusSystem'

import { getUserPromotions } from 'features/bonusSystem/actions'
import { selectBonusPromotionsComm } from 'features/bonusSystem/selectors'

import { Clock } from './Clock'
import { Loading } from './Loading'
import { startTimer } from './data/startTimer'
// import TimerPolling from './TimerPolling' // Not used in component

import './Timer.scss'

// example countDownDate : 'December 17, 2022 13:24:00'
export const BonusTimer: React.FC<{
  countDownDate: string
  payloadFilters: IGetUserPromotionsFilters
}> = ({ countDownDate, payloadFilters }) => {
  const b = block('bonus-timer')
  const dispatch = useDispatch()
  const { isLoading } = useSelector(selectBonusPromotionsComm, shallowEqual)

  const [isExpired, setIsExpired] = useState(false)
  const [residualTime, setResidualTime] = useState({
    days: '0',
    hours: '00',
    minutes: '00',
    seconds: '00',
  })

  const loadUserPromotions = useCallback(() => {
    if (!isExpired && !isLoading) {
      setIsExpired(true)
      dispatch(getUserPromotions(payloadFilters))
    }
  }, [isLoading, isExpired, payloadFilters, dispatch])

  const start = useCallback(async () => {
    if (isExpired) return
    startTimer({
      countDownDate,
      setTime: setResidualTime,
      callback: loadUserPromotions,
    })
  }, [countDownDate, isExpired, loadUserPromotions])

  /* Запрос промоушенов по истечению их срока годности, с примененными фильтрами(на странице которой находишься) */
  usePoll(start, { delay: 1 }, countDownDate, isExpired)

  return (
    <>
      <div className={b()}>
        <div className={b('container')}>
          <Clock
            isExpired={isExpired}
            timerDays={residualTime.days}
            timerHours={residualTime.hours}
            timerSeconds={residualTime.seconds}
            timerMinutes={residualTime.minutes}
          />
        </div>
      </div>
    </>
  )
}
